import { Component, Vue} from 'vue-property-decorator'
import PlantingList from './PlantingList/PlantingList.vue'
import WorkRecordList from './WorkRecordList/WorkRecordList.vue'
import HarvestList from './HarvestList/HarvestList.vue'
import ShippingList from './ShippingList/ShippingList.vue'
import { LoginUser } from "@/types/Component";

@Component({
    components: {
        PlantingList,
        WorkRecordList,
        HarvestList,
        ShippingList
    }
})
export default class List extends Vue {
  navItem = "plantings"
  private isPageInert = false

  get isAdmin(): boolean {
    return this.loginUser.role.find((r: string) => {
      return r === 'ADMIN'
    }) !== undefined;
  }

  get loginUser(): LoginUser {
    return this.$store.getters.loginUser;
  }

  get hasProducerPlanOnly():LoginUser {
    return this.$store.getters.loginUser.hasProducerPlanOnly
  }

  mounted() {
    this.$watch('$store.getters.currentPageName', this.currentMenu, { immediate: true });
  }

  currentMenu(){
    if(this.$store.getters.loginUser.hasProducerPlanOnly === true){
      alert("農薬ナビに参加していない為、利用できません");
      return;
    }
    const path = this.$route.path
    const pathList = path.split('/')
    this.navItem = pathList[2]
  }

  handleInert(val: boolean) {
    this.isPageInert = val
  }
}